<template>
    <div>
        <Gl_leftmenu />
        <Gl_header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Gl_backbutton />
                Оценка по корпоративному стандарту
            </div>
            <div class="content-inner">
                <div class="content-sub-header">
                    Корпоративный стандарт: <i><u>{{ corpstandart.name }}</u></i><br />
                    Сотрудник: <i><u>{{ user.surname }} {{ user.name }} {{ user.third_name }}</u></i>
                    <br><br>
                    Оценочная ведомость
                </div>
                <table>
                    <tr style="border-bottom: 1px solid !important;" v-for="type_of_work in type_of_works_list" :key="type_of_work.type_of_work_id">
                        <th style="width: 400px;">{{ type_of_work.name }} (Max. {{ type_of_work.value }})</th>
                        <td style="min-width: 500px">
                            <tr v-for="aspect in type_of_work.aspects" :key="aspect.aspect_id">
                                <td>{{ aspect.name }} (Max.) {{ aspect.value }})</td>
                                <td style="min-width: 500px">
                                     <input class="content-input" :id="'aspect_'+aspect.aspect_id" type="text" :value="aspect.mark.mark" />
                                </td>
                                <td>
                                    <Btn_svg_save @click="save_mark(aspect.aspect_id)" />
                                </td>
                            </tr>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'
import Btn_svg_save from '@/components/elements/svg/btn_save.vue'

export default {
    name: 'Marking',
    props: ['id', 'event_id'], // id = user_ids
    components: {
        Success, Error, Btn_svg_save
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            type_of_works_list: {},
            corpstandart: {},
            user: {}
        }
    },
    methods: {
        type_of_works() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/marking/'+this.event_id+'/'+this.id)
            .then(response => {
                this.type_of_works_list = response.data.data.type_works
                this.corpstandart = response.data.data.corpstandart
                this.user = response.data.data.user
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        get_input_value(aspect_id) {
            let wordid = '#aspect_'+aspect_id;
            return document.querySelector(wordid).value
        },
        save_mark(aspect_id) {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/marking', {
                aspect_id: aspect_id,
                user_id: this.id,
                event_id: this.event_id,
                mark: this.get_input_value(aspect_id)
            })
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                this.type_of_works()
                loader.hide()
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {
        this.type_of_works()
    }
}
</script>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>